module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src4103618664/src/src/app/common/auto-logout/auto-logout.component.html
// module id = ../../../../../src/app/common/auto-logout/auto-logout.component.html
// module chunks = main